// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"sp_a bha_b bha_bj","SubscribedPhotoblogs__link":"sp_b bha_a bha_r"};